// 获取access_token
export const apiTokenGet = (teanatid: string) => {
    return usePost<LyBase.Site>("main/auth/index", { teanatid })
}

export const apiGetAccessToken = () => {
    return useGet<LyBase.BipToken>("order/bip/getaccesstoken")
}

// 通过url上code获取token
export const apiGetTokenByCode = (code: string) => {
    return useBaseGet("api/order/bipt/ckBipcode", {
        code,
    })
}
